
import { defineComponent, computed } from "vue"
import { useStore } from "vuex"

export default defineComponent({
  setup() {
    const { state, dispatch } = useStore()
    const warningMessage = computed(() => state.warning.warningMessage)
    const waringButtonText = computed(() => state.warning.warningButtonText)
    const warningProcessButtonText = computed(()=> state.warning.warningProcessButtonText)

    const setIsWarning = () => dispatch("warning/closeWarning")
    const setIsProcess = () => dispatch("callgate/callTelephone")

    return {
      warningMessage,
      waringButtonText,
      setIsWarning,
      warningProcessButtonText,
      setIsProcess
    }
  },
})
